<script lang="ts">
    import {InsuredDetails} from "../../models/InsuredDetails";
    import InsuredDetailsEdit from "./InsuredDetailsEdit.svelte";
    import {convertToDateString} from "../../services/Utilities";
     import{ getGender, getMaritalStatus, updateInsuredDetails} from "../../services/ApplicationDataService";
 import {convertToCurrency,  validateEmail, validatePhone} from "../../services/Utilities";
    import {createEventDispatcher} from "svelte";
    export let insuredDetails: InsuredDetails;
    let editMode: Boolean = false;
    let buttonText = 'Edit my information';
    let formInsured;
     let clonedAddress = {...insuredDetails.address};
    const dispatch = createEventDispatcher();

    $: if (insuredDetails) {
        clonedAddress = {...insuredDetails.address}
    }
    const toggleInsuredDetailsEditMode =  () => {
        if (editMode) {
          if( !formInsured.checkValidity()) {
           return false;
           }
          if (!validateEmail(insuredDetails.emailAddress)) {
              return false;
          }
          if (!validatePhone(insuredDetails.phoneNumber)) {
            return false;
          }

            insuredDetails.address = clonedAddress;
            updateInsuredDetails(insuredDetails);
            insuredDetails = {...insuredDetails};
            clonedAddress = {...clonedAddress};
            buttonText = 'Edit my information';
        } else {
            buttonText = 'Close and save my information'
        }

         editMode = !editMode
        dispatch("modeOnChange", editMode);
    }

 // formInsuredValid = formInsured.checkValidity();
</script>
<form bind:this={formInsured}>
<div class="insured-details info-section" style="padding-top:0px; margin-top:0px;">
    <div class="edit-section">
        <h2>Insured Details</h2>
    </div>
    <hr/>

    {#if !editMode}
    <div class="text-section">
        <div class="text-row">
            <div class="text-group">
                <div class="content-text-label">Name:</div>
                <div class="bold-text">{insuredDetails.firstName || ''}  {insuredDetails.middleName || '' } {insuredDetails.lastName || ''} {insuredDetails.suffixName || ''}</div>
            </div>
            <div class="text-group">
                <div class="content-text-label">Birth Date:</div>
                <div class="bold-text">{convertToDateString(insuredDetails.dateOfBirth)}</div>
            </div>
        </div>
        <div class="text-row">
            <div class="text-group">
                <div class="content-text-label">Address:</div>
                {#if clonedAddress}
                    <div class="bold-text">{clonedAddress.address1 || ''} {clonedAddress.address2 || ''}
                    <br/>{clonedAddress.city || ''}, {clonedAddress.state || ''} {clonedAddress.zipCode || ''}</div>
                {/if}
            </div>
            <div class="text-group">
                 <div class="content-text-label">Length of time at residence:</div>
                 <div class="bold-text">{insuredDetails.address.lengthOfResidence || ''}</div>
            </div>
        </div>

        <div class="text-row">


            <div class="text-group">
                <div class="content-text-label">Gender:</div>
                <div class="bold-text">{  getGender(insuredDetails.gender)  }</div>
            </div>
            <div class="text-group">
               <div class="content-text-label">Marital Status:</div>
               <div class="bold-text">{getMaritalStatus(insuredDetails.maritalStatus) }</div>
            </div>

        </div>
 <div class="text-row">

          <div class="text-group">
              <div class="content-text-label">Birth State:</div>
              <div class="bold-text">{insuredDetails.birthState || ''}</div>
          </div>
           <div class="text-group">
                       <div class="content-text-label">Birth Country:</div>
                       <div class="bold-text">{insuredDetails.birthCountry || ''}</div>
                     </div>
      </div>
        <div class="text-row">

             <div class="text-group">
               <div class="content-text-label">Drivers License Number:</div>
               <div class="bold-text">{insuredDetails.driverLicenseNumber || ''}</div>
             </div>
                <div class="text-group">
                                       <div class="content-text-label">Drivers License State</div>
                                       <div class="bold-text">{insuredDetails.driverLicenseState || ''}</div>
                                  </div>

        </div>

              <div class="text-row">
               <div class="text-group">
                           <div class="content-text-label">Employee Type:</div>
                           <div class="bold-text">{insuredDetails.employmentType || ''}</div>
                         </div>
                           <div class="text-group">
                                                       <div class="content-text-label">Phone Number (1):</div>
                                                       <div class="bold-text">{insuredDetails.phoneNumber || ''}</div>
                                                   </div>

               </div>
         <div class="text-row">
                    <div class="text-group">
                        <div class="content-text-label">Phone Number (2):</div>
                        <div class="bold-text">{insuredDetails.phoneNumber2 || ''}</div>
                    </div>
                     <div class="text-group">
                                   <div class="content-text-label">Phone Number (3):</div>
                                   <div class="bold-text">{insuredDetails.phoneNumber3 || ''}</div>
                              </div>

       </div>


      <div class="text-row">

          <div class="text-group">
              <div class="content-text-label">Email Address:</div>
              <div class="bold-text">{insuredDetails.emailAddress || ''}</div>
          </div>
          <div class="text-group">
              <div class="content-text-label">Occupation:</div>
              <div class="bold-text">{insuredDetails.occupation || ''}</div>
          </div>

      </div>
       <div class="text-row">
           <div class="text-group">
               <div class="content-text-label">Annual Income:</div>
               <div class="bold-text">{convertToCurrency(insuredDetails.annualIncome)}</div>
           </div>
                 <div class="text-group">
                   <div class="content-text-label">Net Worth:</div>
                   <div class="bold-text">{convertToCurrency(insuredDetails.netWorth)}</div>
                 </div>
            </div>
    </div>
    {/if}

    {#if editMode}

        <InsuredDetailsEdit insuredDetails={insuredDetails} insuredAddress={clonedAddress}/>

    {/if}
    <div>  <button on:click={toggleInsuredDetailsEditMode} class="card-link buttonWithoutBorder" type="button">{buttonText}</button>
</div>
</div>
</form>
<style lang="scss">
  @use "../../../component_scss_library/layout" as layout;
  @use "../../../component_scss_library/buttons" as buttons;


</style>
